import { Theme, rgbToHex } from '@mui/material';

function extendDefaults() {
  for (let i = 1; i < arguments.length; i++) {
    if (!arguments[i]) {
      continue;
    }
    for (const key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key)) {
        arguments[0][key] = arguments[i][key];
      }
    }
  }
  return arguments[0];
}

const typeCustomTokenizer = [
  {
    name: 'red-alert',
    regex: 'ERROR',
    style: { foreground: '#FF0000', fontStyle: 'bold' },
  },
];

export function initLogLanguage(monaco: any, theme: Theme) {
  if (!monaco) return;
  monaco.languages.register({ id: 'log' });

  const logCustomRules = [];
  const themeRules = [];
  for (let i = 0; i < typeCustomTokenizer.length; i++) {
    try {
      logCustomRules.push([
        new RegExp(typeCustomTokenizer[i].regex),
        typeCustomTokenizer[i].name,
      ]);
      themeRules.push(
        extendDefaults(
          // @ts-ignore params
          { token: typeCustomTokenizer[i].name + '.log' },
          typeCustomTokenizer[i].style,
        ),
      );
    } catch (e) {
      console.error('error', e);
    }
  }

  monaco.languages.setMonarchTokensProvider('log', {
    defaultToken: '',
    tokenPostfix: '.log',
    tokenizer: {
      root: [
        // Custom rules
        ...logCustomRules,
        // Trace
        [/\b(TRACE)\b/, 'trace'],
        // DEBUG
        [/\b(DEBUG)\b/, 'debug'],
        // INFO
        [/\b(HINT|INFO)\b/, 'info'],
        // WARN
        [/\b(WARN)\b/, 'warning'],
        // ERROR
        [/\b(ERROR|FAIL|FATAL)\b/, 'error'],
        // ISO dates ("2020-01-01")
        [/\b\d{4}-\d{2}-\d{2}(T|\b)/, 'date'],
        // Culture specific dates ("01/01/2020", "01.01.2020")
        [/\b\d{2}[^\w\s]\d{2}[^\w\s]\d{4}\b/, 'date'],
        // Clock times with optional timezone ("01:01:01", "01:01:01.001", "01:01:01+01:01")
        [
          /\d{1,2}:\d{2}(:\d{2}([.,]\d{1,})?)?(Z| ?[+-]\d{1,2}:\d{2})?\b/,
          'date',
        ],
        // Git commit hashes of length 40, 10, or 7
        [/\b([0-9a-fA-F]{40}|[0-9a-fA-F]{10}|[0-9a-fA-F]{7})\b/, 'constant'],
        // Guids
        [
          /[0-9a-fA-F]{8}[-]?([0-9a-fA-F]{4}[-]?){3}[0-9a-fA-F]{12}/,
          'constant',
        ],
        // Constants
        [/\b([0-9]+|true|false|null)\b/, 'constant'],
        // String constants
        [/"[^"]*"/, 'string'],
        [/('(?:[^']|'')*')/, 'string'],
        // Colorize rows of exception call stacks
        [/^[\t ]*at.*$/, 'exception'],
        // Match Urls
        [/\b(http|https|ftp|file):\/\/\S+\b\/?/, 'constant'],
        // Match character and . sequences (such as namespaces) as well as file names and extensions (e.g. bar.txt)
        [
          /(?:^|[^A-Za-z0-9_/\\-])([\w-]+\.)+([\w-])+(?![A-Za-z0-9_/\\-])/,
          'constant',
        ],
        [/\[((?:[^[\]"]|"(?:[^"\\]|\\.)*")*)\]\.\d+/, 'id'],
        [/\w+(::\w+)*: \d+:/, 'module'],
        [/(ThreadId\(\d+\))/, 'id'],
        [/^\|.*$/, 'banner'],
      ],
    },
  });

  monaco.editor.defineTheme('logview', {
    base: theme.palette.mode === 'light' ? 'vs' : 'vs-dark',
    inherit: true,
    rules: [
      { token: 'info.log', foreground: rgbToHex(theme.palette.primary.main) },
      {
        token: 'error.log',
        foreground: theme.palette.error.main,
        fontStyle: 'bold',
      },
      {
        token: 'banner.log',
        foreground: rgbToHex(theme.palette.primary.dark),
        fontStyle: 'bold',
      },
      {
        token: 'warning.log',
        foreground: theme.palette.warning.main,
        fontStyle: 'bold',
      },
      { token: 'debug.log', foreground: theme.palette.grey[800] },
      { token: 'trace.log', foreground: theme.palette.grey[600] },
      { token: 'date.log', foreground: theme.palette.grey[400] },
      { token: 'string.log', foreground: theme.palette.success.main },
      { token: 'id.log', foreground: theme.palette.grey[400] },
      { token: 'module.log', foreground: theme.palette.grey[400] },
      ...themeRules,
    ],
    colors: {
      'editor.lineHighlightBackground': theme.palette.background.paper,
      'editorGutter.background': theme.palette.background.paper,
    },
  });
}
